import React from "react";
import { motion } from "framer-motion";
import withStyles from "@mui/styles/withStyles";

export const styles = () => ({
  root: {
    position: "relative",
    width: "min-content",
  },
  bottomSection: {
    position: "absolute",
    bottom: "-6px",
  },
  inverted: {
    transform: "scaleX(-1)",
  },
});

const FriendlyBot = ({
  stroke = "#333",
  backgroundFill = "#F9CA54",
  frontFill = "#39728E",
  height = "55",
  width = "61",
  classes,
  sWidth = "57",
  sHeight = "18",
  flipped = false,
  isAnimated = true,
}) => {
  const [mousePosition, setMousePosition] = React.useState({ x: 0, y: 0 });

  const handleMouseMove = (event) => {
    const boundingRect = event.currentTarget.getBoundingClientRect();
    const mouseX = event.clientX - boundingRect.left;
    const mouseY = event.clientY - boundingRect.top;

    // const eyeRadius = 20;
    const eyeCenterX = boundingRect.width / 2;
    const eyeCenterY = boundingRect.height / 2;

    const deltaX = mouseX - eyeCenterX;
    const deltaY = mouseY - eyeCenterY;
    // const distance = Math.sqrt(deltaX ** 2 + deltaY ** 2);

    // const maxDistance = eyeCenterX - eyeRadius;
    // const normalizedDistance = Math.min(distance, maxDistance);

    const angle = Math.atan2(deltaY, deltaX);
    const offsetX = Math.cos(angle) * 2;
    const offsetY = Math.sin(angle) * 2;

    setMousePosition({
      x: offsetX,
      y: offsetY,
    });
  };

  const handleLeave = (e) => {
    setMousePosition({ x: 0, y: 0 });
  };

  return (
    <div onMouseMove={handleMouseMove} onMouseLeave={handleLeave} className={`${classes.root} ${flipped && classes.inverted}`}>
      <motion.svg
        data-testid="friendly-bot"
        animate={
          isAnimated
            ? {
                y: [1, -10, 1],
              }
            : {}
        }
        transition={
          isAnimated
            ? {
                duration: 1,
                ease: "easeInOut",
                times: [0, 0.2, 0.5, 0.8, 1],
                repeat: Infinity,
                repeatDelay: 5,
              }
            : {}
        }
        width={width}
        height={height}
        viewBox="0 0 60 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_3201_1430)">
          <path
            data-testid="mascot-svg-bg"
            d="M47.2835 6H12.2669C10.607 6.00457 9.01628 6.66571 7.84212 7.83905C6.66796 9.0124 6.00572 10.6026 6 12.2626V33.4226C6.00458 35.0821 6.66585 36.6724 7.83932 37.8459C9.01279 39.0193 10.603 39.6806 12.2626 39.6852H40.4268L47.2792 47.9254V39.6852C48.9387 39.6806 50.529 39.0193 51.7025 37.8459C52.8759 36.6724 53.5372 35.0821 53.5418 33.4226V12.2626C53.5361 10.6041 52.875 9.0152 51.7027 7.8421C50.5304 6.669 48.942 6.00686 47.2835 6Z"
            fill={backgroundFill}
          />
        </g>
        <motion.path
          data-testid="mascot-svg-smile"
          animate={
            isAnimated
              ? {
                  rotate: [0, 10, 0],
                  y: [1, -3, 1],
                  x: [1, -1, 1],
                }
              : {}
          }
          transition={
            isAnimated
              ? {
                  duration: 1,
                  ease: "easeInOut",
                  times: [0, 0.2, 0.5, 0.8, 1],
                  repeat: Infinity,
                  repeatDelay: 5,
                }
              : {}
          }
          d="M28.6136 31.6795C27.5641 31.5841 24.1422 31.2848 23.9688 30.0531C24.0034 29.3462 24.7798 29.7842 25.2135 29.7495C27.552 29.9895 29.9146 29.8133 32.1916 29.2291C33.299 28.9465 34.3658 28.5239 35.3663 27.9714C35.6959 27.7849 35.9951 27.5377 36.3248 27.3816C36.6715 27.1911 37.0486 27.062 37.4394 26.9999C37.6126 26.9761 37.789 27.0013 37.9487 27.0726C38.1084 27.1439 38.2449 27.2585 38.3428 27.4034C38.4407 27.5482 38.4962 27.7176 38.5028 27.8923C38.5095 28.0671 38.4671 28.2402 38.3805 28.3921C37.5825 29.7279 36.0472 30.2917 34.5856 30.7601C32.6795 31.4745 30.6464 31.7875 28.6136 31.6795Z"
          fill={frontFill}
        />
        <g transform={`translate(${mousePosition.x},${mousePosition.y})`}>
          <motion.path
            data-testid="mascot-svg-right-eye"
            animate={
              isAnimated
                ? {
                    scale: [1, 0.5, 1],
                  }
                : {}
            }
            transition={
              isAnimated
                ? {
                    duration: 1,
                    ease: "easeInOut",
                    times: [0, 0.2, 0.5, 0.8, 1],
                    repeat: Infinity,
                    repeatDelay: 5,
                  }
                : {}
            }
            d="M23.2915 21.2484C22.4241 20.1598 22.4892 18.5464 22.9272 17.2887C23.3652 16.031 24.9742 15.4238 25.5294 17.0328C26.0758 18.3166 25.4383 23.1566 23.2915 21.2484Z"
            fill={frontFill}
          />
        </g>
        <g transform={`translate(${mousePosition.x},${mousePosition.y})`}>
          <motion.path
            data-testid="mascot-svg-left-eye"
            animate={
              isAnimated
                ? {
                    scale: [1, 0.5, 1],
                  }
                : {}
            }
            transition={
              isAnimated
                ? {
                    duration: 1,
                    ease: "easeInOut",
                    times: [0, 0.2, 0.5, 0.8, 1],
                    repeat: Infinity,
                    repeatDelay: 5,
                  }
                : {}
            }
            d="M35.2435 21.6823C33.1834 21.2053 33.873 15.9923 35.5948 15.8188C36.9783 15.68 37.2211 17.8788 37.1994 18.8546C37.2558 19.9476 36.692 22.0683 35.2435 21.6823Z"
            fill={frontFill}
            style={{ border: "1px solid red !important" }}
          />
        </g>
        <path
          d="M21.7165 13.98C21.3912 12.9608 23.7202 12.488 24.4271 12.3102C25.0299 12.2408 26.0665 11.8462 26.305 12.6572C26.3197 12.7463 26.3157 12.8376 26.2932 12.9251C26.2707 13.0126 26.2302 13.0945 26.1743 13.1655C26.1184 13.2365 26.0483 13.295 25.9685 13.3375C25.8887 13.3799 25.801 13.4052 25.7108 13.4118C25.2761 13.382 24.8394 13.4038 24.4098 13.4769C23.7923 13.5913 23.1848 13.7537 22.5926 13.9626C22.3107 14.0103 21.9073 14.3096 21.7165 13.98Z"
          fill={frontFill}
        />
        <path
          d="M38.0144 13.98C38.344 12.9608 36.0151 12.488 35.3081 12.3102C34.701 12.2408 33.6688 11.8462 33.4259 12.6572C33.4119 12.7466 33.4165 12.8379 33.4395 12.9255C33.4626 13.013 33.5035 13.0948 33.5598 13.1657C33.616 13.2366 33.6863 13.2951 33.7663 13.3374C33.8463 13.3798 33.9341 13.4051 34.0244 13.4118C34.4591 13.3822 34.8959 13.404 35.3255 13.4769C35.9416 13.5908 36.5478 13.7532 37.1383 13.9626C37.4202 14.0103 37.8279 14.3096 38.0144 13.98Z"
          fill={frontFill}
        />
        <defs>
          <filter id="filter0_d_3201_1430" x="0" y="0" width="59.541" height="53.9253" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
            <feOffset />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3201_1430" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3201_1430" result="shape" />
          </filter>
        </defs>
      </motion.svg>
      <div className={`${classes.bottomSection} ${!isAnimated && "hayley-hidden"}`}>
        <svg width={sWidth} height={sHeight} viewBox="0 0 57 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_f_3201_1428)">
            <path
              d="M28.4196 11.4983C40.5492 11.4983 50.3821 10.3674 50.3821 8.97229C50.3821 7.57722 40.5492 6.44629 28.4196 6.44629C16.29 6.44629 6.45703 7.57722 6.45703 8.97229C6.45703 10.3674 16.29 11.4983 28.4196 11.4983Z"
              fill="#DDDDDD"
            />
          </g>
          <defs>
            <filter
              id="filter0_f_3201_1428"
              x="0.457031"
              y="0.446289"
              width="55.9258"
              height="17.0518"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="3" result="effect1_foregroundBlur_3201_1428" />
            </filter>
          </defs>
        </svg>
      </div>
    </div>
  );
};

export default withStyles(styles)(FriendlyBot);
